<template>
  <div class="museum" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <div class="header" :style="{backgroundColor:isInParallelForumBox?'#ff3c00':'#fff'}">
      <div style="margin-top: 2vh">
        <img src="https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg" style="width: 12vh"
             v-if="isInParallelForumBox">
        <img src="https://summit-img.geekpark.net/IFX-10th%20logo.svg" style="width: 12vh" v-else>
      </div>
      <div>
        <img src="https://summit-img.geekpark.net/ifx/pc/V2-%E7%89%B9%E5%88%AB%E5%B1%95-%E7%99%BD.svg"
             style="width: 10vh" v-if="isInParallelForumBox">
        <img src="https://summit-img.geekpark.net/ifx/pc/V2-%E7%89%B9%E5%88%AB%E5%B1%95.svg"
             style="width: 10vh" v-else>
      </div>
      <div style="margin-bottom: 2vh">
        <img
          src="https://summit-img.geekpark.net/ifx/pc/V2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-%E8%8B%B1%E6%96%87-%E7%99%BD.svg"
          style="width: 9.5vh;" v-if="isInParallelForumBox">
        <img
          src="https://summit-img.geekpark.net/ifx/pc/V2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-%E8%8B%B1%E6%96%87.svg"
          style="width: 9.5vh;" v-else>
      </div>
    </div>
    <div class="body">
      <div class="header-container">
        <div class="plan">
          <img
            src="https://summit-img.geekpark.net/ifx/images/05-%E6%9E%81%E5%AE%A2%E5%8D%9A%E7%89%A9%E9%A6%86-%E7%89%B9%E5%88%AB%E7%AD%96%E5%88%92-%E5%9C%86.svg">
        </div>
        <img
          src="https://summit-img.geekpark.net/05-%E6%9E%81%E5%AE%A2%E5%8D%9A%E7%89%A9%E9%A6%86-%E5%8E%86%E5%8F%B2%E9%A2%84%E8%A7%81%E6%9C%AA%E6%9D%A5.svg"
          style="width: 31vh;position: absolute;top: 20vh;left: 11vh">
      </div>
      <div class="content museumContent">
        <img
          src="https://summit-img.geekpark.net/05-%E6%9E%81%E5%AE%A2%E5%8D%9A%E7%89%A9%E9%A6%86%E4%BA%A7%E5%93%81-1.jpg"
          style="width: 120vh;margin-left: 4vh;transition: transform .5s ease-out;"
          :style="{transform:`translate3d(${topImagePosition}px,0,0)`}">
        <img
          src="https://summit-img.geekpark.net/05-%E6%9E%81%E5%AE%A2%E5%8D%9A%E7%89%A9%E9%A6%86%E4%BA%A7%E5%93%81-2.jpg"
          style="width: 100vh;margin-top:1vh;margin-left: 10vh;transition: transform .5s ease-out;"
          :style="{transform:`translate3d(${middleImagePosition}px,0,0)`}">
        <div class="bottom" :style="{transform:`translate3d(${bottomImagePosition}px,0,0)`}">
          <img
            src="https://summit-img.geekpark.net/05-%E6%9E%81%E5%AE%A2%E5%8D%9A%E7%89%A9%E9%A6%86%E4%BA%A7%E5%93%81-3.jpg"
            style="width: 64vh;margin-top: 1.2vh">
          <div style="width: 52vh">
            <img src="https://summit-img.geekpark.net/05-%E6%9E%81%E5%AE%A2%E5%8D%9A%E7%89%A9%E9%A6%86-logo.svg"
                 style="width: 30vh;margin:2vh 0 0 4.5vh;border-left: 1px solid #E4E4E4;border-right: 1px solid #E4E4E4;">
            <p>
              我们希望找到那些曾经带给我们惊喜和感动的科技产品，带你重拾它们迷人的特质。
            </p>
            <p>
              《极客博物馆》已经成为极客之选最受欢迎的栏目之一，它和无数科技爱好者产生了情感共鸣。我们将在 IF X 期间推出特别展览 ——
              情怀之外，你将有机会重新把玩、审视这些经典产品，它们和现代的科技产品又能碰撞出什么火花？敬请关注。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Museum',
  data () {
    return {
      scrollHeight: 0,
      topImagePosition: 0,
      middleImagePosition: 0,
      bottomImagePosition: 0,
      isInParallelForumBox: false

    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll, false)
  },
  methods: {
    mouseEnter () {
      this.isInParallelForumBox = true
    },
    mouseLeave () {
      this.isInParallelForumBox = false
    },
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scrollInstance = scrollHeight - this.scrollHeight
      this.scrollHeight = scrollHeight
      const { left, width } = document.querySelector('.museumContent').getBoundingClientRect()
      if (left <= document.body.offsetWidth && left >= -width) {
        if ((scrollInstance > 0 && this.topImagePosition >= -width) || (scrollInstance < 0 && this.topImagePosition <= 0)) {
          this.topImagePosition -= scrollInstance / 12
        }
        if ((scrollInstance > 0 && this.middleImagePosition >= -width) || (scrollInstance < 0 && this.middleImagePosition <= 0)) {
          this.middleImagePosition -= scrollInstance / 8
        }
        if ((scrollInstance > 0 && this.bottomImagePosition >= -width) || (scrollInstance < 0 && this.bottomImagePosition <= 0)) {
          this.bottomImagePosition -= scrollInstance / 16
        }
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
  .museum {
    display: flex;
    position: relative;
    height: 100%;
  }

  .header {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 18vh;
    height: 90vh;
    margin-top: 5vh;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    transition: background-color .3s;
  }

  .body {
    width: 190vh;
    height: 91%;
    display: flex;
    justify-content: space-between;
  }

  .header-container {
    width: 48.5vh;
    height: 100vh;
    position: relative;
  }

  .plan {
    position: absolute;
    left: 4vh;
    top: 8vh;
    width: 16vh;
    height: 14vh;
    z-index: 1;

    img {
      width: 16vh;
    }
  }

  .content {
    position: relative;
    margin-left: 14vh;
    text-align: left;

    img {
      display: block;
    }

    .bottom {
      display: flex;
      transition: transform .5s ease-out;

      p {
        margin: 2em 0 0 4.5vh;
        line-height: 2.2;
        text-align: justify;
        font-size: 1.6vh;
        font-weight: 100;
      }
    }
  }
</style>
